import axios from "axios";
import { API_URL } from "../config";
import { ENDPOINTS } from "./endpoints";

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

let refreshPromise = null;

async function refreshAccessToken() {
    if (!refreshPromise) {
        refreshPromise = api
            .post(ENDPOINTS.AUTH.REFRESH)
            .then((res) => res)
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise;
}

// Response interceptor — silent refresh on short-lived access expiry
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;
        const status = error.response?.status;
        const code = error.response?.data?.code;

        if (
            status === 401 &&
            code === "ACCESS_TOKEN_EXPIRED" &&
            original &&
            !original._retry &&
            !String(original.url || "").includes("/auth/refresh") &&
            !String(original.url || "").includes("/auth/login")
        ) {
            original._retry = true;
            try {
                await refreshAccessToken();
                return api(original);
            } catch {
                // Refresh failed — caller / AuthContext will treat as logged out
            }
        }

        return Promise.reject(error);
    }
);

export default api;
